import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCsLZZyFpz94DUHG9dzOHo_aHjDiOxhB78",
  authDomain: "w3skill-exam-prep.firebaseapp.com",
  projectId: "w3skill-exam-prep",
  storageBucket: "w3skill-exam-prep.firebasestorage.app",
  messagingSenderId: "189065282016",
  appId: "1:189065282016:web:35f7c730f155bda6ac6b85",
  measurementId: "G-TVNF0T6TB5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Initialize Analytics with better environment handling
let analytics = null;

const initializeAnalytics = async () => {
  try {
    // Check if analytics is supported in this environment
    const analyticsSupported = await isSupported();
    if (analyticsSupported) {
      analytics = getAnalytics(app);
      console.log('Firebase Analytics initialized successfully');
    } else {
      console.log('Firebase Analytics not supported in this environment');
    }
  } catch (error) {
    console.warn('Analytics initialization failed:', error);
  }
};

// Initialize analytics
initializeAnalytics();

export { analytics };
export default app;
